import {type GetProps, wrap} from '../../components/util/Controls/wrap';
import {ReactRouterLink} from './ReactRouterLink';

export const Link = wrap(ReactRouterLink);
export type LinkProps = GetProps<typeof ReactRouterLink>;
